import { Component, Input } from '@angular/core';
import { ApplicationActions } from '../../actions/application.actions';
import { NgRedux } from '@angular-redux/store';
import * as _ from 'lodash';
import { MaskingService } from '../../shared/services/masking.service';

@Component({
  selector: 'md-noneditable',
  template: require('./noneditable.component.html')
})

export class NoneditableComponent {
  @Input() options;

  noneditableValue = '';

  constructor(
    appActions: ApplicationActions,
    ngRedux: NgRedux,
    masking: MaskingService
  ) {
    this.appActions = appActions;
    this.ngRedux = ngRedux;
    this.masking = masking;
  }

  ngOnInit() {
    if (this.options.attr.inputClass === undefined) {
      this.options.attr.inputClass = '';
    }
    this.inputClass = this.options.attr.inputClass;

    if (this.options.inputPath) {
      const arrayPath = this.options.inputPath.split('.');

      arrayPath.unshift('applicationStore');
      this.arrayPath = arrayPath;

      if (this.options.inputPath.match(/\[\d+\]/) !== -1) {
        this.reduxObservable$ = this.ngRedux.select((state) =>
          _.get(state, `applicationStore.${this.options.inputPath}`)
        );
      } else {
        this.reduxObservable$ = this.ngRedux.select(this.arrayPath);
      }

      this.reduxSubscription = this.reduxObservable$.subscribe((state) => {
        this.noneditableValue =
          state === null ||
          state === undefined ||
          (state && Object.keys(state).length === 0)
            ? '-'
            : state;

        if (
          (this.noneditableValue != null || this.init === true) &&
          this.noneditableValue !== undefined
        ) {
          switch (this.options.inputPath) {
            // eslint-disable-next-line no-case-declarations
            case 'YourInformation.fullName':
              const fullName = this.appActions.getData(
                'YourInformation.fullName',
                {}
              );
              this.noneditableValue = fullName;
              break;
            // eslint-disable-next-line no-case-declarations
            case 'YourInformation.email':
              const email = this.appActions.getData(
                'YourInformation.email',
                {}
              );
              this.noneditableValue = email;
              break;
            // eslint-disable-next-line no-case-declarations
            case 'PersonalInformation.mobilePhone':
              const mobilePhone = this.appActions.getData(
                'PersonalInformation.mobilePhone',
                {}
              );
              this.noneditableValue = mobilePhone;
              break;
            default:
              this.noneditableValue = this.state;
          }
        }

        this.init = true;
      });

      // Set default value if it exists in schema and state is null
      this.defaultValue = this.options.attr.defaultValue || null;
      this.initialReduxValue = this.appActions.getData(this.options.inputPath);
      if (
        !this.initialReduxValue &&
        this.defaultValue !== null &&
        this.init === false
      ) {
        this.appActions.setData(this.options.inputPath, this.defaultValue);
      }

    }
  }

  ngAfterContentInit() {
    if (this.options.inputPath === 'BeneficiaryInformation.Primary[0].percent') {
      return;
    }
    if (this.options.inputPath !== undefined) {
      if (this.appActions.getData(this.options.inputPath) !== null) {
        this.options.noneditable = this.appActions.getData(this.options.inputPath);
      }
    }
  }
}
